<template>
  <div class="loading">
    <object width="100%" height="80px" data="/loader.svg" type="image/svg+xml"></object>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: 'Loader',
  data: () => {
    return {
      loading: false
    }
  }
}
</script>
